import { useAuth } from "@/context/AuthContext";

/** Per-engagement Dinacharya destinations (Google Sheets / Apps Script web apps).
 *  Configured by an Aikyam admin in Admin → Client engagements → Edit; every engagement
 *  keeps its own set, and a card with no link simply stays non-clickable. */
export const DINACHARYA_LINK_KEYS = [
  ["daily_review_tracker", "Daily review tracker"],
  ["monthly_planner", "Monthly planner"],
  ["monthly_review_tracker", "Monthly review tracker"],
  ["score_categorisation", "Score categorisation"],
];

export const useDinacharyaLinks = () => {
  const { tenantId, tenants } = useAuth();
  const tenant = (tenants || []).find((t) => t.id === tenantId);
  return tenant?.dinacharya_links || {};
};
